import React, { FunctionComponent } from 'react';

import withIconContainer from './withIconContainer';

const IconChevronDown: FunctionComponent = () => (
    <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
    </svg>
);

export default withIconContainer(IconChevronDown);
